import React from "react";
import { Box, Title } from "gold-ui-kit";

// Box appends its own padding/radius/overflow after ours, hence the ! overrides.
const ClassicWindow = ({ title, icon = null, children, className = "", contentClassName = "", width = "auto" }) => (
  <Box
    className={`flex min-h-full flex-col !overflow-visible !rounded-none !border-0 !p-0 !shadow-none ${className}`}
    style={{ width }}
    data-testid="classic-window"
  >
    <div className="flex items-center gap-2.5 border-b border-slate-100 px-5 py-3.5" data-testid="window-title-wrap">
      <span className="h-5 w-1 rounded-full bg-amber-500" />
      {icon && <span className="text-sm">{icon}</span>}
      <Title size="xs" className="!text-[15px] tracking-tight text-slate-900" title={<span data-testid="window-title">{title}</span>} />
    </div>
    <div className={`flex-1 ${contentClassName}`}>{children}</div>
  </Box>
);

export default ClassicWindow;
